<template>
    <div id="dvtelalogin" v-show="usuario.id === null">
        <div class="container-fluid" style="height: 100%;">
            <div class="row" style="height: 100%;">   
                <div class="col-md-9" id="dvlogin" style="padding-bottom: 15px;">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-2 col-lg-4">
                            </div>
                            <div class="col-md-8 col-lg-5">
                                <div class="col-md-12">
                                    <img src="@/assets/managerweblogo.png" class="mx-auto d-block img-fluid">
                                </div>                                
                                <div class="col-sm-12 col-md-12 col-lg-12" style="margin-top: 10px;">
                                    <h6 style="font-size: 14px; font-weight: 700;">Informe suas credenciais de acesso.</h6>
                                </div>                                
                                <div class="input-group col-sm-12 col-md-12 col-lg-12">
                                    <input type="number" id="edidcliente" class="form-control text-center" placeholder="Id. Cliente" min="1" v-model="idcliente" @blur="mtdcarregardadoscli()">
                                    <div class="input-group-prepend">
                                        <button type="button" id="btsistema" class="btn btn-primary dropdown-toggle btn-sm" data-toggle="dropdown">
                                            {{sistemaselecionado.nomesis}}
                                        </button>
                                        <div class="dropdown-menu">
                                            <a v-for='(sistema, index) in lstsistemascliente' v-bind:key="index" class="dropdown-item" href="#" @click.prevent="mtdselecionasistema(sistema)">{{sistema.nomesis}}</a>
                                        </div>
                                    </div>                                    
                                </div>                                
                                <div v-if="nomecliente !== ''" class="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <div id="dvnomecliente">{{nomecliente}}</div>
                                </div>                                
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <label for="edusuario">Usuário:</label>
                                    <input type="text" class="form-control" id="edusuario"
                                    maxlength="20" v-model="loginusuario"/>
                                </div>              
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <label for="edsenha">Senha:</label>
                                    <input type="password" class="form-control" id="edsenha"
                                    maxlength="20" v-model="senhausuario"/>
                                </div>
                                <div class="col-md-12" style="padding-top: 10px;">
                                    <button id="btlogar" type="button" @click.prevent="mtdlogarusuario()" class="btn btn-primary btn-block"><i class="fa fa-sign-in"></i> Logar
                                    </button>                                    
                                </div>
                            </div>
                            <div class="col-md-2 col-lg-3">
                            </div>                                                        
                        </div>
                    </div>
                </div>
                <div class="col-md-3" id="dvside">
                    <div class="row" style="padding: 15px;">
                        <div class="col-md-12" style="padding: 50px 0px 10px 0px;">
                            <img src="@/assets/sidelogowhite.png" class="mx-auto d-block img-fluid">
                        </div>
                        <div class="col-md-12" style="padding-top: 30px;">
                            <h6 style="color: white; font-weight: 400;">Seja bem vindo a sua plataforma de <strong>gerenciamento</strong>!</h6>
                        </div>
                    </div> 
                    <div class="col-md-12" style="margin-top: 50px;">
                        <h6 style="font-size: 13px; color: white; font-weight: 100;">Ainda não conhece a <strong>Rillsoft Sistemas</strong>? Clique no botão abaixo e saiba mais sobre nós.</h6>                                           
                    </div>
                    <div class="col-md-12 text-right" style="margin-top: 15px; padding-bottom: 15px;">
                        <a href="http://www.rillsoftsistemas.com.br" target="_blank" class="btn btn-primary btn-sm btn-green" style="font-size: 12px; width: 130px;">Saiba mais...</a>
                    </div>
                </div>                                 
            </div>
        </div>    
    </div>
</template>
<script>
import { ClientJS } from 'clientjs';
import util from '../utilitarios/util.js'
export default {
  name: "login",
  data: function() {
    return {     
        idcliente           : '',        
        lstsistemascliente  : [],
        sistemaselecionado  : [],
        nomecliente         : '',
        loginusuario        : '',
        senhausuario        : '',
        chavedispositivo     : null,
    };
  },
  methods:{
      mtdlogarusuario(){
        var vself           = this;   

        if (this.idcliente === ''){
            this.$toastr.w('Id. do cliente deve ser informado!', 'Atenção!');
            $('#edidcliente').focus();
            return;
        }
        if (this.loginusuario === ''){
            this.$toastr.w('Login do usuário deve ser informado!', 'Atenção!');
            $('#edusuario').focus();
            return;
        }        
        if (this.senhausuario === ''){
            this.$toastr.w('Senha do usuário deve ser informada!', 'Atenção!');
            $('#edsenha').focus();
            return;
        }      
        if (this.sistemaselecionado.length === 0){
            this.$toastr.w('Informe o sistema para o acesso!', 'Atenção!');
            $('#btsistema').focus();
            return;            
        }
         
        
        let loader          = vself.$loading.show();             
        let dthracesso      = new Date();
        let parametros      = [
            {parametro: 'op',           valor : 'logarws'}, 
            {parametro: 'loginusu',     valor : vself.loginusuario}, 
            {parametro: 'senhausu',     valor : vself.senhausuario},
            {parametro: 'idclientesac', valor : vself.idcliente},
            {parametro: 'idcliente',    valor : vself.idcliente}
        ];
        //quando for testar habilitar essa linha
        ///vself.sistemaselecionado.endereco = 'rillsoft-dev.cloud';
        
        let retorno     = util.reqaxios(parametros, 'post', vself.sistemaselecionado.endereco+'/controller/rotinasusuario.php');
        retorno.then(function (response) {
            loader.hide();
            if (parseInt(response.data.qtdusu) > 0){
                let payload = {
                    id                      : parseInt(response.data.idusuario),
                    nome                    : response.data.nome,
                    foto                    : response.data.foto,
                    descgrupo               : response.data.descgrupo,
                    todasfiliais            : response.data.todasfiliais,
                    operaperfilfluxo        : response.data.operaperfilfluxo,
                    todastabelas            : response.data.todastabelas,
                    idvendedor              : response.data.idvendedor,
                    nomevendedor            : response.data.nomevendedor,
                    descontoprodutos        : response.data.descontoprodutos,
                    descontoprodutosprazo   : response.data.descontoprodutosprazo,
                    descontoservicos        : response.data.descontoservicos,
                    descontojuros           : response.data.descontojuros,
                    descontomulta           : response.data.descontomulta,
                    descontotit             : response.data.descontotit,

                    cardresumopedidos         : response.data.cardresumopedidos,
                    cardfinanceiro            : response.data.cardfinanceiro,
                    cardvendedores            : response.data.cardvendedores,
                    cardtop5produtos          : response.data.cardtop5produtos,
                    cardgiroproduto           : response.data.cardgiroproduto,
                    cardcompra                : response.data.cardcompra,
                    cardpicovendas            : response.data.cardpicovendas,
                    cardmetaindividual        : response.data.cardmetaindividual,
                    carddemoresultado         : response.data.carddemoresultado,
                    cardmetas                 : response.data.cardmetas,
                    carddemotecnico           : response.data.carddemotecnico,
                    cardtotalestoque          : response.data.cardtotalestoque,
                    cardcomprasfiliais        : response.data.cardcomprasfiliais,
                    cardcomprassetores        : response.data.cardcomprassetores,
                    cardcomprasgrupos         : response.data.cardcomprasgrupos,
                    cardcomprasmarcas         : response.data.cardcomprasmarcas,
                    cardmetafilial            : response.data.cardmetafilial,
                    cardvendasvendedores      : response.data.cardvendasvendedores,
                    cardvendassubgrupos       : response.data.cardvendassubgrupos,
                    cardvendassetores         : response.data.cardvendassetores,
                    cardvendasplanospagamento : response.data.cardvendasplanospagamento,
                    cardvendasmunicipios      : response.data.cardvendasmunicipios,
                    cardvendasmarcas          : response.data.cardvendasmarcas,
                    cardvendasgrupos          : response.data.cardvendasgrupos,
                    cardvendasformaspagamento : response.data.cardvendasformaspagamento,
                    cardvendasfiliais         : response.data.cardvendasfiliais,
                    cardvendascategorias      : response.data.cardvendascategorias,
                    cardvariacaofaturamento   : response.data.cardvariacaofaturamento,
                    cardprevisaorecebimento   : response.data.cardprevisaorecebimento,
                    cardprevisaopagamento     : response.data.cardprevisaopagamento,
                    cardprodutosparados       : response.data.cardprodutosparados, 
                    cardfaturamentofilial     : response.data.cardfaturamentofilial,
                    cardsaldocaixa            : response.data.cardsaldocaixa,
                    cardvendasbairros         : response.data.cardvendasbairros,

                    exibicaocard              : response.data.exibicaocard,

                    definirsenhalogin       : response.data.definirsenhalogin,
                    idclientesac            : vself.idcliente,
                    dbcliente               : vself.sistemaselecionado.dbcliente,
                    sistema                 : vself.sistemaselecionado.nomesis,
                    adrsrv                  : vself.sistemaselecionado.endereco,
                    tpsistema               : parseInt(vself.sistemaselecionado.tpsistema),
                    limitecreditoautorizar  : response.data.limitecreditoautorizar,
                    qtddiastolatraso        : response.data.qtddiastolatraso,
                    qtddiasbloqvenda        : response.data.qtddiasbloqvenda,
                    receberinfsistema       : response.data.receberinfsistema,
                    estoquegeralconsultas   : response.data.estoquegeralconsultas,
                    tabelasusuario          : response.data.tabelasusuario,
                    senhausu                : String(response.data.senhausu),
                    formulacusto            : String(response.data.formulacusto)                     
                };
                vself.$store.commit('MUDAR_USUARIO_LOGADO',payload);
                 
                 
                //Muda o configpath
                payload = {
                    pathcontrole    : 'https://www.'+vself.sistemaselecionado.endereco+'/controller/',
                    pathselect2     : 'https://www.'+vself.sistemaselecionado.endereco+'/controller/select2remoto.php',
                    pathselect2sql  : 'https://www.'+vself.sistemaselecionado.endereco+'/controller/select2sql.php',
                    pathimagens     : 'https://www.'+vself.sistemaselecionado.endereco+'/',
                    patharquivos    : 'https://www.'+vself.sistemaselecionado.endereco+'/',
                    pathvideos      : 'https://www.'+vself.sistemaselecionado.endereco+'/', 
                    pathconferencias: 'arquivos/manager/conferencias/',                        
                    pathretornos    : 'arquivos/manager/retornos/',        
                    pathofx         : 'arquivos/manager/ofx/',        
                    pathimgprodutos : 'imagens/manager/produtos/',
                    pathimgpedidos  : 'imagens/manager/pedidos/',
                    pathimgfiliais  : 'imagens/manager/filiais/',
                    pathimgclientes : 'imagens/manager/clientes/',
                    pathimgusuarios : 'imagens/manager/usuarios/',
                    pathvideosexercicios : 'videos/manager/exercicios/',
                    pathcertificados     : 'arquivos/manager/certificados/',
                    pathtarefas          : 'arquivos/manager/tarefas/'                    
                }
                vself.$store.commit('MUDAR_CONFIG_PATHS',payload);
                let client = new ClientJS();
                let descnav = client.getBrowserData().browser.name;

                // Gerando chave de acesso do dispositivo
                let userAgent = client.getBrowserData().ua;
                let os = client.getOS();
                let device = client.getDevice();
                const dados = `${userAgent}|${os}|${device}`;
                vself.chavedispositivo = client.getCustomFingerprint(dados);

                window.localStorage.setItem('tpsistema',              parseInt(vself.sistemaselecionado.tpsistema));
                window.localStorage.setItem('dbcliente',              vself.sistemaselecionado.dbcliente);
                window.localStorage.setItem('sistema',                vself.sistemaselecionado.nomesis);                
                window.localStorage.setItem('adrsrv',                 vself.sistemaselecionado.endereco);                
                window.localStorage.setItem('idcliente',              vself.idcliente);
                window.localStorage.setItem('idusuario',              parseInt(response.data.idusuario));
                window.localStorage.setItem('nome',                   response.data.nome);
                window.localStorage.setItem('idvendedor',             parseInt(response.data.idvendedor));
                window.localStorage.setItem('nomevendedor',           response.data.nomevendedor);
                window.localStorage.setItem('descontoprodutos',       response.data.descontoprodutos);
                window.localStorage.setItem('descontoprodutosprazo',  response.data.descontoprodutosprazo);
                window.localStorage.setItem('descontoservicos',       response.data.descontoservicos);
                window.localStorage.setItem('descontojuros',          response.data.descontojuros);
                window.localStorage.setItem('descontomulta',          response.data.descontomulta);
                window.localStorage.setItem('descontotit',            response.data.descontotit);

                window.localStorage.setItem('cardresumopedidos',         response.data.cardresumopedidos);
                window.localStorage.setItem('cardfinanceiro',            response.data.cardfinanceiro);
                window.localStorage.setItem('cardvendedores',            response.data.cardvendedores);
                window.localStorage.setItem('cardtop5produtos',          response.data.cardtop5produtos);
                window.localStorage.setItem('cardgiroproduto',           response.data.cardgiroproduto);
                window.localStorage.setItem('cardcompra',                response.data.cardcompra);
                window.localStorage.setItem('cardpicovendas',            response.data.cardpicovendas);
                window.localStorage.setItem('cardmetaindividual',        response.data.cardmetaindividual);
                window.localStorage.setItem('carddemoresultado',         response.data.carddemoresultado);
                window.localStorage.setItem('cardmetas',                 response.data.cardmetas);
                window.localStorage.setItem('carddemotecnico',           response.data.carddemotecnico);
                window.localStorage.setItem('cardtotalestoque',          response.data.cardtotalestoque);
                window.localStorage.setItem('cardcomprasfiliais',        response.data.cardcomprasfiliais);
                window.localStorage.setItem('cardcomprassetores',        response.data.cardcomprassetores);
                window.localStorage.setItem('cardcomprasgrupos',         response.data.cardcomprasgrupos);
                window.localStorage.setItem('cardcomprasmarcas',         response.data.cardcomprasmarcas);
                window.localStorage.setItem('cardmetafilial',            response.data.cardmetafilial);
                window.localStorage.setItem('cardvendasvendedores',      response.data.cardvendasvendedores);
                window.localStorage.setItem('cardvendassubgrupos',       response.data.cardvendassubgrupos);
                window.localStorage.setItem('cardvendassetores',         response.data.cardvendassetores);
                window.localStorage.setItem('cardvendasplanospagamento', response.data.cardvendasplanospagamento);
                window.localStorage.setItem('cardvendasmunicipios',      response.data.cardvendasmunicipios);
                window.localStorage.setItem('cardvendasmarcas',          response.data.cardvendasmarcas);
                window.localStorage.setItem('cardvendasgrupos',          response.data.cardvendasgrupos);
                window.localStorage.setItem('cardvendasformaspagamento', response.data.cardvendasformaspagamento);
                window.localStorage.setItem('cardvendasfiliais',         response.data.cardvendasfiliais);
                window.localStorage.setItem('cardvendascategorias',      response.data.cardvendascategorias);
                window.localStorage.setItem('cardvariacaofaturamento',   response.data.cardvariacaofaturamento);
                window.localStorage.setItem('cardprevisaorecebimento',   response.data.cardprevisaorecebimento);
                window.localStorage.setItem('cardprevisaopagamento',     response.data.cardprevisaopagamento);
                window.localStorage.setItem('cardprodutosparados',       response.data.cardprodutosparados);
                window.localStorage.setItem('cardfaturamentofilial',     response.data.cardfaturamentofilial);
                window.localStorage.setItem('cardsaldocaixa',            response.data.cardsaldocaixa);
                window.localStorage.setItem('cardvendasbairros',         response.data.cardvendasbairros);
                
                window.localStorage.setItem('exibicaocard',              response.data.exibicaocard);

                window.localStorage.setItem('limitecreditoautorizar', response.data.limitecreditoautorizar);   
                window.localStorage.setItem('qtddiastolatraso',       response.data.qtddiastolatraso);   
                window.localStorage.setItem('qtddiasbloqvenda',       response.data.qtddiasbloqvenda);   
                window.localStorage.setItem('receberinfsistema',      response.data.receberinfsistema);   
                window.localStorage.setItem('estoquegeralconsultas',  response.data.estoquegeralconsultas);                   
                window.localStorage.setItem('foto',                   response.data.foto);
                window.localStorage.setItem('descgrupo',              response.data.descgrupo);
                window.localStorage.setItem('todasfiliais',           response.data.todasfiliais);
                window.localStorage.setItem('operaperfilfluxo',       response.data.operaperfilfluxo);
                window.localStorage.setItem('todastabelas',           response.data.todastabelas);
                window.localStorage.setItem('definirsenhalogin',      vself.definirsenhalogin);
                window.localStorage.setItem('loginusu',               vself.loginusuario);
                window.localStorage.setItem('senhausu',               String(response.data.senhausu));                
                window.localStorage.setItem('dthracesso',             dthracesso);
                window.localStorage.setItem('tabelasusuario',         JSON.stringify(response.data.tabelasusuario));
                window.localStorage.setItem('evahc',                  vself.chavedispositivo);
                window.localStorage.setItem('navg',                   descnav);
                window.localStorage.setItem('apelido',                'Novo dispositivo');
                
                // Verifica permissão de acesso
                // Verifica permissão de dispositivos
                util.controlaacessodispositivo(vself);

                // Verifica permissão de horários    
                util.controlaacessousuario(vself);

                //limpa variáveis do login
                $("#dvconteudoapp").css({"display": "block"});         
                vself.dbcliente    = '';
                vself.loginusuario = '';
                vself.senhausuario = '';                
            }else{                
                vself.$toastr.w(response.data.msg, 'Atenção!');    
                $('#edusuario').focus();
            }
        }).catch(function (response) {
            loader.hide();
            console.log(response.message);
            vself.$toastr.e('Erro ao tentar fazer o login do usuário. Favor tente novamente mais tarde.', 'Erro!');
        });        
      },
      mtdcarregardadoscli(){
        var vself           = this;   
        if (vself.idcliente.trim() !== ''){            
            let loader          = vself.$loading.show();             
            let parametros      = [
                {parametro: 'op',           valor : 'dadoslogin'}, 
                {parametro: 'idclientesac', valor : vself.idcliente}
            ];
            //conecta direto no servidor do sac para coletar as informações do clientes
            let retorno     = util.reqaxios(parametros, 'post', 'rillsoft.app/sacweb/controller/auxiliares.php');
            retorno.then(function (response) {
                loader.hide();
                if (response.data.fantasia !== ''){
                    vself.nomecliente           = response.data.fantasia;
                    vself.lstsistemascliente    = response.data.sistemas;  
                    if (vself.lstsistemascliente.length === 0){
                        vself.nomecliente           = '';
                        vself.lstsistemascliente    = [];                      
                        vself.sistemaselecionado    = [];                        
                        vself.$toastr.i('Cliente sem contrato(s) ativo(s)!', 'Atenção!');    
                        $('#edidcliente').focus();                    
                    }else{                  
                        if (vself.lstsistemascliente.length > 0){
                            vself.mtdselecionasistema(vself.lstsistemascliente[0]);
                        }else{
                            vself.sistemaselecionado = [];
                        }
                        $('#edusuario').focus(); 
                    }
                }else{                
                    vself.nomecliente           = '';
                    vself.lstsistemascliente    = [];                      
                    vself.sistemaselecionado    = [];
                    vself.$toastr.w('Cliente não encontrado ou sem contrato ativo!', 'Atenção!');    
                    $('#edidcliente').focus();
                }
            }).catch(function (response) {
                loader.hide();
                console.log(response.message);
                vself.$toastr.e('Erro ao tentar carregar informações do cliente. Favor tente novamente mais tarde.', 'Erro!');
            }); 
        }                 
      },
      mtdselecionasistema(sistema){
          this.sistemaselecionado = sistema;
      }
  },
  mounted: function () {          
        let vself = this;
        $(document).keypress(function(e) {
            if (e.which == 13) {
                if (window.localStorage.getItem('idusuario') === null){
                    vself.mtdlogarusuario();
                }                
            }
        });        
        if (window.localStorage.getItem('idusuario') != null){      
            let payload = {
                id                     : window.localStorage.getItem('idusuario'),
                nome                   : window.localStorage.getItem('nome'),
                foto                   : window.localStorage.getItem('foto'),
                descgrupo              : window.localStorage.getItem('descgrupo'),
                todasfiliais           : window.localStorage.getItem('todasfiliais'),
                idvendedor             : window.localStorage.getItem('idvendedor'),
                nomevendedor           : window.localStorage.getItem('nomevendedor'),
                descontoprodutos       : window.localStorage.getItem('descontoprodutos'),
                descontoprodutosprazo  : window.localStorage.getItem('descontoprodutosprazo'),
                descontoservicos       : window.localStorage.getItem('descontoservicos'),
                descontojuros          : window.localStorage.getItem('descontojuros'),
                descontomulta          : window.localStorage.getItem('descontomulta'),
                cardresumopedidos         : window.localStorage.getItem('cardresumopedidos'),
                cardfinanceiro            : window.localStorage.getItem('cardfinanceiro'),
                cardvendedores            : window.localStorage.getItem('cardvendedores'),
                cardtop5produtos          : window.localStorage.getItem('cardtop5produtos'),
                cardgiroproduto           : window.localStorage.getItem('cardgiroproduto'),
                cardcompra                : window.localStorage.getItem('cardcompra'),
                cardpicovendas            : window.localStorage.getItem('cardpicovendas'),
                cardmetaindividual        : window.localStorage.getItem('cardmetaindividual'),
                carddemoresultado         : window.localStorage.getItem('carddemoresultado'),
                cardmetas                 : window.localStorage.getItem('cardmetas'),
                carddemotecnico           : window.localStorage.getItem('carddemotecnico'),
                cardtotalestoque          : window.localStorage.getItem('cardtotalestoque'),
                cardcomprasfiliais        : window.localStorage.getItem('cardcomprasfiliais'),
                cardcomprassetores        : window.localStorage.getItem('cardcomprassetores'),
                cardcomprasgrupos         : window.localStorage.getItem('cardcomprasgrupos'),
                cardcomprasmarcas         : window.localStorage.getItem('cardcomprasmarcas'),
                cardmetafilial            : window.localStorage.getItem('cardmetafilial'),
                cardvendasvendedores      : window.localStorage.getItem('cardvendasvendedores'),
                cardvendassubgrupos       : window.localStorage.getItem('cardvendassubgrupos'),
                cardvendassetores         : window.localStorage.getItem('cardvendassetores'),
                cardvendasplanospagamento : window.localStorage.getItem('cardvendasplanospagamento'),
                cardvendasmunicipios      : window.localStorage.getItem('cardvendasmunicipios'),
                cardvendasmarcas          : window.localStorage.getItem('cardvendasmarcas'),
                cardvendasgrupos          : window.localStorage.getItem('cardvendasgrupos'),
                cardvendasformaspagamento : window.localStorage.getItem('cardvendasformaspagamento'),
                cardvendasfiliais         : window.localStorage.getItem('cardvendasfiliais'),
                cardvendascategorias      : window.localStorage.getItem('cardvendascategorias'),
                cardvariacaofaturamento   : window.localStorage.getItem('cardvariacaofaturamento'),
                cardprevisaorecebimento   : window.localStorage.getItem('cardprevisaorecebimento'),
                cardprevisaopagamento     : window.localStorage.getItem('cardprevisaopagamento'),
                cardprodutosparados       : window.localStorage.getItem('cardprodutosparados'),
                cardfaturamentofilial     : window.localStorage.getItem('cardfaturamentofilial'),   
                cardvendasbairros         : window.localStorage.getItem('cardvendasbairros'),

                exibicaocard              : window.localStorage.getItem('exibicaocard'),

                cardsaldocaixa            : window.localStorage.getItem('cardsaldocaixa'),
                dbcliente              : window.localStorage.getItem('dbcliente'),
                idclientesac           : window.localStorage.getItem('idcliente'),
                sistema                : window.localStorage.getItem('sistema'),
                adrsrv                 : window.localStorage.getItem('adrsrv'),
                tpsistema              : window.localStorage.getItem('tpsistema'),
                definirsenhalogin      : window.localStorage.getItem('definirsenhalogin'),
                limitecreditoautorizar : window.localStorage.getItem('limitecreditoautorizar'),
                qtddiastolatraso       : window.localStorage.getItem('qtddiastolatraso'),
                qtddiasbloqvenda       : window.localStorage.getItem('qtddiasbloqvenda'),
                receberinfsistema      : window.localStorage.getItem('receberinfsistema'),
                estoquegeralconsultas  : window.localStorage.getItem('estoquegeralconsultas'),
                todastabelas           : window.localStorage.getItem('todastabelas'),   
                operaperfilfluxo       : window.localStorage.getItem('operaperfilfluxo'),   
                senhausu               : window.localStorage.getItem('senhausu'),  
                tabelasusuario         : JSON.parse(window.localStorage.getItem('tabelasusuario')),     
            };            
            this.$store.commit('MUDAR_USUARIO_LOGADO',payload);

            //Muda o configpath
            payload = {
                pathcontrole    : 'https://www.'+window.localStorage.getItem('adrsrv')+'/controller/',
                pathselect2     : 'https://www.'+window.localStorage.getItem('adrsrv')+'/controller/select2remoto.php',
                pathselect2sql  : 'https://www.'+window.localStorage.getItem('adrsrv')+'/controller/select2sql.php',
                pathimagens     : 'https://www.'+window.localStorage.getItem('adrsrv')+'/',
                patharquivos    : 'https://www.'+window.localStorage.getItem('adrsrv')+'/',
                pathvideos      : 'https://www.'+window.localStorage.getItem('adrsrv')+'/', 
                pathconferencias: 'arquivos/manager/conferencias/',                        
                pathretornos    : 'arquivos/manager/retornos/',        
                pathofx         : 'arquivos/manager/ofx/',        
                pathimgprodutos : 'imagens/manager/produtos/',
                pathimgpedidos  : 'imagens/manager/pedidos/',
                pathimgfiliais  : 'imagens/manager/filiais/',
                pathimgclientes : 'imagens/manager/clientes/',                
                pathimgusuarios : 'imagens/manager/usuarios/',
                pathcertificados: 'arquivos/manager/certificados/',
                pathvideosexercicios : 'videos/manager/exercicios/',
                pathtarefas          : 'arquivos/manager/tarefas/'                    
            }
            this.$store.commit('MUDAR_CONFIG_PATHS',payload);            
        }
        if (this.usuario.id === null){            
            $('#edidcliente').focus();
            $("#dvconteudoapp").css({"display": "none"});         
        }
  },
  computed:{
    usuario (){
        return this.$store.state.usuario;
    }      
  },
  watch:{
  }    
}
</script>
<style>
    #btsistema{
        border-top-left-radius: 0px !important; 
        border-bottom-left-radius: 0px !important;
    }
    #edidcliente, #edusuario, #edsenha{
        /* text-align: center; */
        font-weight: bolder !important;
        color: #666666 !important;
    }
    #dvtelalogin{
        position: absolute;
        top: 0;
        z-index: 1032;
        width: 100%;
        height: 100%;
        background: #343a40;
    }
    #dvside{
        /* background: black; */
        background-image: linear-gradient(to right top, #01060e, #0d1a29, #112946, #163864, #214883);
    }
    #dvlogin{
        padding-top: 50px;
        background: white;
    }    
    label, h6{
        color: #666666;
        font-weight: 700;
    }
    #dvnomecliente{
        margin-top: 10px;
        margin-bottom: 5px;
        border: 1px solid #0acf97;
        border-radius: 4px;        
        background: #0acf97;
        width: 100%;
        color: white;
        font-weight: 500;
        padding: 10px;
    }
</style>